var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.890625%",
    y1: "23.6697266%",
    x2: "16.1979167%",
    y2: "77.8068359%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA2D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AF2F",
    offset: "26.3492506%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA930",
    offset: "52.8858418%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9732",
    offset: "76.5545281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8B32",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components-/-Z-Symbols-/-Icons-/-Small-/-Warning",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(2.666667, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4305274,21.3307073 L14.8455979,0.888373979 C14.1740869,-0.29612466 12.4925797,-0.29612466 11.8210687,0.888373979 L0.23613931,21.3307073 C-0.435371679,22.5152059 0.405381918,24 1.7484039,24 L24.9182628,24 C26.2612847,24 27.1020383,22.5152059 26.4305274,21.3307073 Z M13.3497117,6.90540462 C14.0921953,6.90540462 14.6927336,7.53380061 14.6708959,8.29010021 L14.4525183,16.0532932 C14.43614,16.6650061 13.9447905,17.1488154 13.3442522,17.1488154 C12.7437139,17.1488154 12.2523644,16.6594451 12.2359861,16.0532932 L12.023068,8.29010021 C12.0066897,7.53380061 12.6017685,6.90540462 13.3497117,6.90540462 Z M13.3333333,21.6699299 C12.5744713,21.6699299 11.9575547,21.0415339 11.9575547,20.2685512 C11.9575547,19.4955686 12.5744713,18.8671726 13.3333333,18.8671726 C14.0921953,18.8671726 14.7091119,19.4955686 14.7091119,20.2685512 C14.7091119,21.0415339 14.0921953,21.6699299 13.3333333,21.6699299 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.ce9e6a51c31fb52d025d8cc427303501.svg";
export { ForwardRef as ReactComponent };